export default __webpack_public_path__ + "static/img/47.cea9e7c.png";